import { saveAs } from "file-saver";
import XLSX from "xlsx";



export const useExportXLSX = () => {

    const s2ab = (s) => {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    };
    
   const processFile = (sheetName,columns,data,nameFile) => {
    const wb = XLSX.utils.book_new()

    wb.SheetNames.push(sheetName)

    const ws_data = [columns]
    data.map((item)=> {
        ws_data.push(item)
    })
    const ws = XLSX.utils.aoa_to_sheet(ws_data)
    wb.Sheets[sheetName] = ws
    const wbout = XLSX.write(wb,{bookType:'xlsx',type:'binary'})
    saveAs(new Blob([s2ab(wbout)],{
     type:'application/octet-stream'
    }),`${nameFile}.xlsx`)

  }
  return {processFile}
}

